import { render } from "./PsNotificationBox.vue?vue&type=template&id=ed7f7ffa"
import script from "./PsNotificationBox.vue?vue&type=script&lang=js"
export * from "./PsNotificationBox.vue?vue&type=script&lang=js"

import "./PsNotificationBox.vue?vue&type=style&index=0&id=ed7f7ffa&lang=css"

import exportComponent from "C:\\Users\\DELL\\download\\advertisingServiceWebApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__